const colors = {
  CIN: "#002664",
  CINsecondary: "#f3631b",
  SLSprimary: "#ea1b36",
  SLSsecondary: "#005ab3",
};

export default colors;
